"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _strings = require("../common_features/utility/strings");
var _StoreDashboardComponent = _interopRequireDefault(require("../components/StoreDashboardComponent"));
var _helper = require("../common_features/utility/helper");
var _RoutePath = _interopRequireDefault(require("../RoutePath"));
var _reactRedux = require("react-redux");
var _index = _interopRequireDefault(require("../common_features/assets/images/index"));
var _systemsReducer = require("../common_features/redux/reducers/systemsReducer");
var _gatewayReducer = require("../common_features/redux/reducers/gatewayReducer");
var _alertReducer = require("../common_features/redux/reducers/alertReducer");
var _roleReducer = require("../common_features/redux/reducers/roleReducer");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const StoreDashboard = () => {
  const store = {};
  const [storeAlertCount, setStoreAlertCount] = (0, _react.useState)([]);
  const {
    selectedStore
  } = (0, _reactRedux.useSelector)(state => state.stores);
  const {
    systems
  } = (0, _reactRedux.useSelector)(state => state.systems);
  const {
    gateways
  } = (0, _reactRedux.useSelector)(state => state.gateway);
  const {
    sysLoading
  } = (0, _reactRedux.useSelector)(state => state.systems);
  const {
    gateLoading
  } = (0, _reactRedux.useSelector)(state => state.gateway);
  const {
    userInfo
  } = (0, _reactRedux.useSelector)(state => state.login);
  const {
    userScreenPref
  } = (0, _reactRedux.useSelector)(state => state.role);
  const [storeImage, setStoreImage] = (0, _react.useState)('');
  const dispatch = (0, _reactRedux.useDispatch)();
  const navigate = (0, _reactRouterDom.useNavigate)();
  const [isLoading, setIsLoading] = (0, _react.useState)(false);
  const [imageLoading, setImageLoading] = (0, _react.useState)(false);
  const [displayZoomImage, setDisplayZoomImage] = (0, _react.useState)(false);
  const handleBack = () => {
    if (userInfo.userType === 4 || userInfo.userType === 5) {
      if (userScreenPref !== "" && sessionStorage.getItem("Dispatcher_Web_Mobile_View")) {
        dispatch((0, _roleReducer.setUserScreenPref)(""));
        navigate(_RoutePath.default.manageStore.useLink);
      } else {
        navigate(_RoutePath.default.admin.useLink);
      }
    } else {
      navigate(_RoutePath.default.admin.useLink);
    }
  };
  const handleClickSystem = (item, type) => {
    console.log("item:-", item);
    if ((selectedStore === null || selectedStore === void 0 ? void 0 : selectedStore.isActive) === true) {
      switch (type) {
        case "system":
          dispatch((0, _systemsReducer.selectSystems)({
            ...item
          }));
          navigate(_RoutePath.default.systemDetail.useLink);
          break;
        case "gateway":
          dispatch((0, _gatewayReducer.selectGateway)({
            ...item
          }));
          navigate(_RoutePath.default.gatewayDetail.useLink);
          break;
        case "detail":
          navigate(_RoutePath.default.StoreAlertList.useLink);
          break;
      }
    }
  };
  (0, _react.useEffect)(() => {
    const customCall = () => {
      (0, _helper.getSystemsData)(selectedStore, dispatch, navigate, setStoreAlertCount, _systemsReducer.systemsLoading, _gatewayReducer.gatewayLoading, setIsLoading, store, 4);
    };
    customCall();
    if (selectedStore !== null && selectedStore !== void 0 && selectedStore.imageSubPath) {
      setImageLoading(true);
      (0, _helper.fetchImage)(selectedStore === null || selectedStore === void 0 ? void 0 : selectedStore.imageSubPath, setImageLoading, setStoreImage);
    }
  }, []);
  const optionBtnClick = item => {
    dispatch((0, _alertReducer.selectedAlertData)({
      ...item,
      id: item.id,
      storeId: selectedStore.storeId
    }));
    navigate(_RoutePath.default.StoreAlertsDetails.useLink);
  };
  const isSystemPresent = systems => {
    return systems !== null && systems !== void 0 && systems.length ? true : false;
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_StoreDashboardComponent.default, {
    string: _strings.storeDashboardString,
    heading: "STORE DASHBOARD",
    subHeading: "ServiceConnect",
    separator: "|",
    handleBack: handleBack,
    name: selectedStore.name,
    address: (0, _helper.isJSON)(selectedStore.address) ? (0, _helper.bindAddress)(JSON.parse(selectedStore.address)) : selectedStore.address,
    loginType: "owner",
    systems: systems,
    gateways: gateways,
    onclick: handleClickSystem,
    sysLoading: sysLoading,
    gateLoading: gateLoading,
    onDetailsTileClick: () => {
      handleClickSystem(null, 'detail');
    },
    isDisable: selectedStore === null || selectedStore === void 0 ? void 0 : selectedStore.isActive,
    systemType: "system",
    gatewayType: "gateway",
    waterDestinationItem: _strings.waterDestinationItem,
    rightButtonShow: selectedStore !== null && selectedStore !== void 0 && selectedStore.isActive ? true : false,
    dscIcon: (selectedStore === null || selectedStore === void 0 ? void 0 : selectedStore.isActive) === true ? _index.default.everythingOkIcon.default : _index.default.subscriptionExpireIcon.default,
    everythingOkIcon: (selectedStore === null || selectedStore === void 0 ? void 0 : selectedStore.isActive) === true ? _index.default.everythingOkIcon.default : _index.default.subscriptionExpireIcon.default,
    successLabel: (selectedStore === null || selectedStore === void 0 ? void 0 : selectedStore.isActive) === true ? _strings.storeTileStrings.SUCCESS_LABEL : "Subscription Expired",
    rightArrowBtn: selectedStore === null || selectedStore === void 0 ? void 0 : selectedStore.isActive,
    everythingOkText: selectedStore !== null && selectedStore !== void 0 && selectedStore.isActive ? _strings.storeTileStrings.SUCCESS_LABEL : "Monitoring Suspended",
    isSystem: isSystemPresent(systems),
    statusIcon: _index.default.greenDot.default,
    statusText: "Online",
    storeAlertList: storeAlertCount,
    isLoading: isLoading,
    optionBtnClick: optionBtnClick,
    systemsText: "Systems",
    storeImage: storeImage ? storeImage : _index.default.noImg.default,
    storeImageStyle: storeImage ? {
      width: "100%",
      height: "100%",
      borderRadius: 10
    } : {
      margin: "0px auto",
      height: "65px"
    },
    imageLoading: imageLoading,
    zoomImageAction: () => {
      setDisplayZoomImage(true);
    },
    displayZoomImage: displayZoomImage,
    crossIconAction: () => {
      setDisplayZoomImage(false);
    },
    userScreenPref: userScreenPref
  }));
};
var _default = exports.default = StoreDashboard;